import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { ConfirmStakingPage } from "./confirm-staking.page";

const routes: Routes = [
  {
    path: "",
    component: ConfirmStakingPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ConfirmStakingPage],
})
export class ConfirmStakingPageModule {}
